import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import apis from '../../apis'
import { axiosGet } from '../../axiosHelper'
import {
  aiTutorCourseDetail,
  aiTutorCourseList,
  aiTutorExpressionCount,
  aiTutorJobDetail,
  aiTutorJobs,
  aiTutorLatestJob,
  aiTutorLessonDetail,
  aiTutorMembership,
  aiTutorRoleplayDetail,
  aiTutorRoleplayList,
  aiTutorStreak,
  aiTutorSummary,
  aiTutorSummaryCourse,
  aiTutorSummaryMembership,
  aiTutorSummaryStreak,
  aiTutorUserJob,
} from '../../react-query/queryApis'

export const useLessonDetail = (lessonId, enabled = true) => {
  const pathParams = { lessonId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorLessonDetail.getQueryKey({ pathParams }),
    queryFn: aiTutorLessonDetail.getQueryFn({ pathParams }),
    enabled,
  })
}

export const useCourseDetail = (courseId, enabled = true) => {
  const pathParams = { courseId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorCourseDetail.getQueryKey({ pathParams }),
    queryFn: aiTutorCourseDetail.getQueryFn({ pathParams }),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled,
  })
}

export const useRoleplayDetail = (roleplayId, enabled = true) => {
  const pathParams = { roleplayId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorRoleplayDetail.getQueryKey({ pathParams }),
    queryFn: aiTutorRoleplayDetail.getQueryFn({ pathParams }),
    refetchOnWindowFocus: true,
    cacheTime: 0,
    enabled,
  })
}

export const getAITutorRoleplay = async (roleplayId) => {
  try {
    const res = await axiosGet(apis.aiTutor.roleplay.detail({ roleplayId }))
    return res
  } catch (e) {
    console.error(e)
  }
}

export const getRoleplayExpressions = async (roleplayId) => {
  try {
    return []
  } catch (e) {
    console.log(e)
  }
}

export const useAITutorCourseList = ({ jobId, jobCategoryId }) => {
  const pathParams = { jobId, jobCategoryId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorCourseList.getQueryKey({ pathParams }),
    queryFn: aiTutorCourseList.getQueryFn({ pathParams }),
  })
}

export const getAITutorRoleplayList = async (jobId, jobCategoryId) => {
  try {
    const res = await axiosGet(apis.aiTutor.roleplay.list({ jobId, jobCategoryId }))
    return res
  } catch (e) {
    console.error(e)
  }
}

export const useAITutorRoleplayList = ({ jobId, jobCategoryId }: { jobId?: number; jobCategoryId?: number }) => {
  const pathParams = { jobId, jobCategoryId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorRoleplayList.getQueryKey({ pathParams }),
    queryFn: aiTutorRoleplayList.getQueryFn({ pathParams }),
  })
}

export const useJobCategories = (jobId) => {
  const pathParams = { jobId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorJobDetail.getQueryKey({ pathParams }),
    queryFn: aiTutorJobDetail.getQueryFn({ pathParams }),
  })
}

export const useAITutorSummary = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorSummary.getQueryKey(),
    queryFn: aiTutorSummary.getQueryFn(),
  })
}
export const useAITutorSummaryStreak = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorSummaryStreak.getQueryKey(),
    queryFn: aiTutorSummaryStreak.getQueryFn(),
  })
}
export const useAITutorSummaryCourse = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorSummaryCourse.getQueryKey(),
    queryFn: aiTutorSummaryCourse.getQueryFn(),
  })
}
export const useAITutorSummaryMembership = (service) => {
  const pathParams = { service }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorSummaryMembership.getQueryKey({ pathParams }),
    queryFn: aiTutorSummaryMembership.getQueryFn({ pathParams }),
    refetchOnWindowFocus: true,
  })
}
export const useJobDetail = (jobId) => {
  const pathParams = { jobId }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorJobDetail.getQueryKey({ pathParams }),
    queryFn: aiTutorJobDetail.getQueryFn({ pathParams }),
  })
}

export const useAITutorJobs = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorJobs.getQueryKey(),
    queryFn: aiTutorJobs.getQueryFn(),
  })
}

export const useAITutorUserJob = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorUserJob.getQueryKey(),
    queryFn: aiTutorUserJob.getQueryFn(),
  })
}

export const useAITutorLatestJob = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorLatestJob.getQueryKey(),
    queryFn: aiTutorLatestJob.getQueryFn(),
  })
}

export const useAITutorStreak = () => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorStreak.getQueryKey(),
    queryFn: aiTutorStreak.getQueryFn(),
  })
}

export const useAITutorPermission = (service, config = {}) => {
  const pathParams = { service }

  return useQuery<any, AxiosError>({
    queryKey: aiTutorMembership.getQueryKey({ pathParams }),
    queryFn: aiTutorMembership.getQueryFn({ pathParams }),
    ...config,
  })
}

export const useExpressionCount = (enabled = true) => {
  return useQuery<any, AxiosError>({
    queryKey: aiTutorExpressionCount.getQueryKey(),
    queryFn: aiTutorExpressionCount.getQueryFn(),
    enabled,
  })
}
